import React from 'react';
import { node } from 'prop-types';
import { ssrDataShape } from 'shapes';
import StateContext from './SSRDataContext';

const SSRDataProvider = ({ children, data }) => (
    <StateContext.Provider value={data}>{children}</StateContext.Provider>
);

SSRDataProvider.propTypes = {
    children: node.isRequired,
    data: ssrDataShape,
};

SSRDataProvider.defaultProps = {
    data: {},
};

export default SSRDataProvider;
